module.exports = __webpack_public_path__ + "static/img/fish51.e360e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish51.png
// module id = dAAQ
// module chunks = 0